import type { SlideImage } from "yet-another-react-lightbox";

export function Gallery2019(){

const slides: SlideImage[] = [
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_001.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_001.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_002.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_002.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_003.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_003.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_004.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_004.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_005.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_005.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_006.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_006.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_007.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_007.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_008.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_008.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_009.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_009.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_010.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_010.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_011.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_011.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_012.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_012.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_013.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_013.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_014.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_014.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_015.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_015.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_016.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_016.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_017.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_017.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_018.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_018.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_019.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_019.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_020.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_020.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_021.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_021.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_022.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_022.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_023.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_023.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_024.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_024.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_025.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_025.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_026.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_026.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_027.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_027.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_028.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_028.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_029.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_029.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_030.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_030.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_031.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_031.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_032.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_032.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_033.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_033.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_034.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_034.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_035.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_035.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_036.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_036.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_037.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_037.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_038.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_038.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_039.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_039.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_040.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_040.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_041.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_041.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_042.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_042.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_043.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_043.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_044.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_044.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_045.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_045.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_046.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_046.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_047.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_047.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_048.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_048.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_049.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_049.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_050.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_050.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_051.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_051.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_052.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_052.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_053.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_053.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_054.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_054.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_055.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_055.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_056.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_056.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_057.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_057.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_058.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_058.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_059.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_059.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_060.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_060.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_061.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_061.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_062.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_062.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_063.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_063.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_064.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_064.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_065.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_065.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_066.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_066.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_067.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_067.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_068.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_068.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_069.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_069.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_070.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_070.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_071.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_071.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_072.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_072.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_073.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_073.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_074.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_074.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_075.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_075.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_076.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_076.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_077.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_077.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_078.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_078.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_079.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_079.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_080.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_080.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_081.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_081.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_082.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_082.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_083.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_083.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_084.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_084.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_085.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_085.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_086.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_086.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_087.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_087.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_088.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_088.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_089.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_089.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_090.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_090.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_091.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_091.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_092.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_092.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_093.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_093.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_094.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_094.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_095.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_095.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_096.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_096.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_097.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_097.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_098.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_098.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_099.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_099.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_100.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_100.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2019/IMG_101.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2019/SML_101.jpg"
        }
     ];

     return slides;
} 
